/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Dropdown_Nooptions2Inputs */

const en_formfields_dropdown_nooptions2 = /** @type {(inputs: Formfields_Dropdown_Nooptions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {Formfields_Dropdown_Nooptions2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_dropdown_nooptions2 = /** @type {((inputs?: Formfields_Dropdown_Nooptions2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Dropdown_Nooptions2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_dropdown_nooptions2(inputs)
});
export { formfields_dropdown_nooptions2 as "formFields_dropdown_noOptions" }